import axios from 'axios'
import Noty from 'noty';

var http = null
var baseURL = null

class WebService {
    constructor({}) {
        baseURL = process.env.BASE_URL
        http = axios.create({
            baseURL: process.env.BASE_URL
        })
    }

    getAPI({ _action, _body, _buttonId, _hide_loader }) {
        let params = new URLSearchParams()
        for (let key in _body) {
            params.set(key, _body[key])
        }

        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }

        return http
            .get(_action, {
                params: params,
                headers: this.getHeader()
            })
            .then(response => {
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e)
            })
    }

    postAPI({ _action, _body, _buttonId, _hide_loader }) {
        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }

        return http
            .post(_action, JSON.stringify(_body), { headers: this.getHeader() })
            .then(response => {
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e)
            })
    }

    putAPI({ _action, _body, _buttonId, _hide_loader }) {
        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }
        return http
            .put(_action, JSON.stringify(_body), { headers: this.getHeader() })
            .then(response => {
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e)
            })
    }

    deleteAPI({ _action, _buttonId, _hide_loader }) {
        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }
        return http
            .delete(_action, { headers: this.getHeader() })
            .then(response => {
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e)
            })
    }


    uploadImageAPI({ _action, _file, _key, _body, _buttonId, _hide_loader }) {
        if (!_key) {
            _key = 'file'
        }
        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }
        let formData = new FormData()
        formData.append(_key, _file)
        for (let key in _body) {
            formData.append(key, _body[key])
        }

        return http
            .post(_action, formData, { headers: this.addHeaderForMultipart() })
            .then(response => {
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e)
            })
    }

    getAccesstoken({ _action, _body, _buttonId, _hide_loader }) {
        this.addLoader(_buttonId, _hide_loader)
        var headers = {}

        headers['Content-Type'] = 'application/json'

        return http
            .post(_action, JSON.stringify(_body), { headers: headers })
            .then(response => {
                localStorage.setItem('admin_token', response.data.access_token)
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e)
            })
    }

    _errorHandler(error) {
        if (error.response != null) {
            error = error.response
        }
        var errorMessage
        if (!error || !error.status) {
            errorMessage = 'Server Not Responding'
        } else if (error.status === 401) {
            errorMessage =
                (error && error.data && error.data.message) || 'Bad Response'
            localStorage.removeItem('candidate_token')
            this.logout()
        } else if (error.status === 500) {
            errorMessage = 'Server Error'
        } else {
            errorMessage =
                (error && error.data && error.data.message) || 'Bad Response'
        }

        new Noty({
            type: 'error',
            text: errorMessage,
            timeout: 2000
        }).show();

        throw new Error(errorMessage)
    }

    logout() {
        localStorage.clear()
        // window.location.href = '/login'
    }

    getHeader() {
        var headers = this.getHeaders();
        headers['Accept'] = 'application/json';
        headers['Content-Type'] = 'application/json'
        return headers;
    }

    addHeaderForMultipart() {
        return this.getHeaders();
    }

    getHeaders() {
        var headers = {}
        if (localStorage.getItem('admin_token')) {
            headers['Authorization'] = 'Bearer ' + localStorage.getItem('candidate_token')
        }
        return headers;
    }
    addLoader(id, _hide_loader) {
        if (id) {
            var button = document.getElementById(id)
            if (button.disabled) {
                return true
            }

            button.disabled = true
            var loader = document.createElement('i')
            loader.className = 'fa fa-spinner fa-spin mr-2'
            button.prepend(loader)
            return false
        }
    }

    getBaseUrl() {
        return baseURL
    }

    getServerUrl() {
        return process.env.APP_URL;
    }

    removeLoader(id, _hide_loader) {
        if (id) {
            var button = document.getElementById(id)
            button.disabled = false
            button.removeChild(button.childNodes[0])
        }
    }
}

export default new WebService({})



// WEBPACK FOOTER //
// ./src/service/Webservice.js